import { Box, FormControl, InputLabel, MenuItem, Select, TextField, Typography } from "@mui/material";
import DesignationSelect from "../../utils/designationSelect";

// Converts dd-MM-yyyy (stored) → yyyy-MM-dd (for HTML date input display)
const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    const [day, month, year] = dateString.split("-");
    return `${year}-${month}-${day}`;
};

// Converts yyyy-MM-dd (from HTML date input) → dd-MM-yyyy (for storage / backend)
const formatDateForStorage = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
};


const AppraisalLetterForm = ({ data, setData }) => {

    const handleChange = (key, value) => {
        if (key === "appraisal_date" || key === "effective_date") {
            value = formatDateForStorage(value);
        }

        setData(prev => ({
            ...prev,
            [key]: value
        }));
    };

    return (
        <Box sx={{ mt: 1 }}>

            

            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
                    gap: 2
                }}
            >
                <Box>
                    <TextField
                        type="date"
                        label="Appraisal Date"
                        fullWidth
                        slotProps={{
                            inputLabel: {
                                shrink: true,
                            },
                        }}
                        value={data.appraisal_date ? formatDateForInput(data.appraisal_date) : ""}
                        onChange={(e) => handleChange("appraisal_date", e.target.value)}
                    />
                </Box>

                <Box>
                    <TextField
                        label="Employee Code"
                        fullWidth
                        value={data.employee_code || ""}
                        onChange={(e) => handleChange("employee_code", e.target.value)}
                    />
                </Box>

                <Box>
                    <DesignationSelect
                        value={data.designation || ""}
                        onChange={(e) => handleChange("designation", e.target.value)}
                    />
                </Box>

                <Box>
                    <TextField
                        type="date"
                        label="Effective Date"
                        fullWidth
                        slotProps={{
                            inputLabel: {
                                shrink: true,
                            },
                        }}
                        value={data.effective_date ? formatDateForInput(data.effective_date) : ""}
                        onChange={(e) => handleChange("effective_date", e.target.value)}
                    />
                </Box>

                <Box>
                    <TextField
                        type="number"
                        label="Current CTC"
                        fullWidth
                        value={data.current_ctc || ""}
                        onChange={(e) => handleChange("current_ctc", e.target.value)}
                    />
                </Box>

                <Box>
                    <TextField
                        label="Revised CTC"
                        fullWidth
                        value={data.revised_ctc || ""}
                        onChange={(e) => handleChange("revised_ctc", e.target.value)}
                    />
                </Box>

                <Box>
                    <FormControl fullWidth>
                        <InputLabel id="rating-grade-label">Rating / Grade</InputLabel>
                        <Select
                            labelId="rating-grade-label"
                            label="Rating / Grade"
                            value={data.rating_grade || ""}
                            onChange={(e) => handleChange("rating_grade", e.target.value)}
                        >
                            <MenuItem value="Below Average">Below Average</MenuItem>
                            <MenuItem value="Average">Average</MenuItem>
                            <MenuItem value="Above Average">Above Average</MenuItem>
                            <MenuItem value="Good">Good</MenuItem>
                            <MenuItem value="Very Good">Very Good</MenuItem>
                            <MenuItem value="Excellent">Excellent</MenuItem>
                            <MenuItem value="Exceeds Expectations">Exceeds Expectations</MenuItem>
                        </Select>
                    </FormControl>
                </Box>
            </Box>
        </Box>
    );
};

export default AppraisalLetterForm;
